import Video from 'app/components/tv/models/video';

interface AdKeywordsInterface {
  competition: string | null;
  homeTeam: string | null;
  awayTeam: string | null;
  region: string;
  source: string;
}

export default class AdKeywords implements AdKeywordsInterface {
  competition: string | null;
  homeTeam: string | null;
  awayTeam: string | null;
  region: string;
  source: string;

  private constructor(data: AdKeywordsInterface) {
    Object.assign(this, data);
  }

  static fromVideo(video: Video): AdKeywords {
    return new AdKeywords({
      competition: video.match?.competition.slug ?? null,
      homeTeam: video.match?.homeTeam?.clubSlug ?? null,
      awayTeam: video.match?.awayTeam?.clubSlug ?? null,
      region: video.getRegionSlug(),
      source: video.category,
    });
  }

  toParamString(): string {
    return Object.entries(this)
      .filter(([, value]) => value !== null)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
  }
}
